import { Constants, StyleSheetType, StyleValueType } from '@/helpers';

class Api {
	create(obj: StyleSheetType): StyleSheetType {
		return Object.keys(obj).reduce(
			(acc, key) => ({
				...acc,
				[key]: this.format(obj[key]),
			}),
			{},
		);
	}

	format(obj: StyleValueType) {
		return Object.keys(obj).reduce(
			(acc, key) => ({
				...acc,
				[key]: this.value(obj[key]),
			}),
			{},
		);
	}

	value(key: string) {
		if (!key || key[0] !== '$') {
			return key;
		}

		const value = Constants[key];
		const nextKeyValue = Constants[value];

		if (nextKeyValue) {
			return this.value(value);
		}

		return value;
	}
}

export const StyleSheet = new Api();
